<template>
    <span style="font-size: 12px;">
        <!-- <i class="el-icon-view"></i> -->
         <!-- {{ appVisits[keys[0]] }} -->
           <!-- {{ appVisits }} -->
           <!-- {{ target }} -->
         访问量：{{ appVisits[target.text] ? appVisits[target.text] : 0 }}
        <!-- 访问量：{{ appVisits[keys[0]] && appVisits[keys[0]][target.id] ? appVisits[keys[0]][target.id] : 0 }} -->
        <!-- 次 -->
        <!-- &nbsp;
        <i class="el-icon-edit"></i>
        {{ appVisits[keys[1]] && appVisits[keys[1]][target.id] ? appVisits[keys[1]][target.id] : 0  }}次 -->
    </span>
</template>
<script>
import _ from "lodash";
import { mapGetters, mapState } from "vuex";

export default {
  name: "visit",
  data() {
    return {
      // "",
      // "VIEW_BY_APP" 
      keys:["VISITS_BY_APP"]
    };
  },
  props: {
    target: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    
    
  },
  watch: {
    target:{
        handler(val,oldVal){
            
        },
        deep: true,
        immediate: true
    }
  },
  computed: {
    ...mapState(["appVisits"]),
  },
};
</script>
<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/todoCenter/visit.vue